<template>
  <a-config-provider :locale="antdLanguage" v-bind="defaultConfig">
    <template #renderEmpty>
      <div style="text-align: center">
        <dc-layout-empty type="nothing" />
      </div>
    </template>
    <router-view />
  </a-config-provider>
</template>

<script setup lang="ts">
import { shareInfo } from '@dc-platform/dc-interaction'
import useLocale from '@/hooks/useLocale'
import { getLanguage } from '@/lang'
import { useInteractionStore } from '@/stores/interaction'
import type { ConfigProviderProps } from 'ant-design-vue'
const interactionStore = useInteractionStore()

enum SystemLanguageEnum {
  'zh-cn' = 'zh-CN', // 简体中文（为了兼容主应用老版本）
  'en-us' = 'en-US', // 英文(为了兼容主应用老版本)
  'zh-CN' = 'zh-CN', // 简体中文
  'en-US' = 'en-US' // 英文
}

const { antdLanguage, languageToggle } = useLocale()

const defaultConfig: ConfigProviderProps = {
  input: {
    autocomplete: 'off'
  }
}

const mainAppLanguage = SystemLanguageEnum[shareInfo.getLanguage()]
languageToggle(mainAppLanguage)
interactionStore.setLanguage(mainAppLanguage)
console.log(mainAppLanguage)
shareInfo.onLanguage((language: string) => {
  console.log('主应用切换语言 :>> ', language, getLanguage())
  interactionStore.setLanguage(getLanguage())
  languageToggle(SystemLanguageEnum[language])
})
</script>

<style lang="scss">
#app {
  display: flex;
  position: relative;
  flex-direction: column;
  min-height: calc(100vh - 104px);
  height: 100%;
  color: #333333;
}
</style>
